// import React, { createContext, useContext, useState, useEffect } from 'react';
// import strapiAPI from "../api/strapi";
// import { getStrapiData } from "../utils/helpers"; // Assuming this is correct

// // 1. Create the Context
// const StrapiConstantsContext = createContext(null);

// // 2. Define the initial state structure
// const initialConstants = {
//     loaded: false,
//     homePage: null,
//     contactPage: null,
//     socialLink: null,
//     error: null,
// };

// // 3. Create the Provider Component
// export const StrapiConstantsProvider = ({ children }) => {
//     const [constants, setConstants] = useState(initialConstants);

//     useEffect(() => {
//         const fetchConstants = async () => {
//             try {
//                 const [homePageRes, contactPageRes, socialLinkRes] = await Promise.all([
//                     strapiAPI.get("/api/home-page?populate=*"),
//                     strapiAPI.get("/api/contact-page"),
//                     strapiAPI.get("/api/social-link")
//                 ]);

//                 // Combine and normalize the data
//                 const loadedConstants = {
//                     loaded: true,
//                     homePage: getStrapiData(homePageRes),
//                     contactPage: getStrapiData(contactPageRes),
//                     socialLink: getStrapiData(socialLinkRes),
//                     error: null,
//                 };

//                 setConstants(loadedConstants);

//             } catch (error) {
//                 console.error("❌ Error fetching Strapi constants:", error);
//                 setConstants(prev => ({
//                     ...prev,
//                     loaded: true, // Mark as loaded even if there's an error
//                     error: "Failed to load global constants."
//                 }));
//             }
//         };

//         fetchConstants();
//     }, []);

//     return (
//         <StrapiConstantsContext.Provider value={constants}>
//             {children}
//         </StrapiConstantsContext.Provider>
//     );
// };

// // 4. Create a Custom Hook to consume the context
// export const useStrapiConstants = () => {
//     const context = useContext(StrapiConstantsContext);
//     if (context === undefined) {
//         throw new Error('useStrapiConstants must be used within a StrapiConstantsProvider');
//     }
//     return context;
// };





import React, { createContext, useContext, useState, useEffect } from "react";
import strapiAPI from "../api/strapi";
import { getStrapiData } from "../utils/helpers";

// ---------------------
// 1. Create Context
// ---------------------
const StrapiConstantsContext = createContext(null);

// ---------------------
// 2. Initial State
// ---------------------
const initialConstants = {
    loaded: false,
    homePage: null,
    contactPage: null,
    socialLink: null,
    error: null,
};

// ---------------------
// 3. Provider Component
// ---------------------
export const StrapiConstantsProvider = ({ children }) => {
    const [constants, setConstants] = useState(initialConstants);

    useEffect(() => {
        // ---------------------------------
        // A. Try reading from localStorage
        // ---------------------------------
        // const cached = localStorage.getItem("STRAPI_CONSTANTS");

        // if (cached) {
        //     const parsed = JSON.parse(cached);
        //     setConstants({ ...parsed, loaded: true });
        //     return; // ✅ No API calls
        // }

        // ---------------------------------
        // B. Prevent StrictMode double-fetch
        // ---------------------------------
        if (constants.loaded) return;

        // ---------------------------------
        // C. Fetch from Strapi
        // ---------------------------------
        const fetchConstants = async () => {
            try {
                const [homePageRes, contactPageRes, socialLinkRes, directorates, symposium] =
                    await Promise.all([
                        strapiAPI.get("/api/home-page?populate=*"),
                        strapiAPI.get("/api/contact-page"),
                        strapiAPI.get("/api/social-link"),
                        strapiAPI.get("/api/directorates?fields[0]=slug&fields[1]=displayTitle&populate[Directorate][fields][0]=title"),
                        strapiAPI.get("/api/main-symposia?fields=slug&populate[symposium][fields]=title&sort=createdAt:desc"),

                    ]);

                const loadedConstants = {
                    loaded: true,
                    homePage: getStrapiData(homePageRes),
                    contactPage: getStrapiData(contactPageRes),
                    socialLink: getStrapiData(socialLinkRes),
                    directorates: getStrapiData(directorates),
                    symposium: getStrapiData(symposium),

                    error: null,
                };

                // ---------------------------------
                // D. Save to localStorage (cache)
                // ---------------------------------
                localStorage.setItem(
                    "STRAPI_CONSTANTS",
                    JSON.stringify(loadedConstants)
                );

                setConstants(loadedConstants);
            } catch (error) {
                console.error("❌ Error fetching Strapi constants:", error);
                setConstants({
                    loaded: true,
                    homePage: null,
                    contactPage: null,
                    socialLink: null,
                    directorates: null,
                    error: "Failed to load global constants.",
                });
            }
        };

        fetchConstants();
    }, [constants.loaded]);

    return (
        <StrapiConstantsContext.Provider value={constants}>
            {children}
        </StrapiConstantsContext.Provider>
    );
};

// ---------------------
// 4. Custom Hook
// ---------------------
export const useStrapiConstants = () => {
    const context = useContext(StrapiConstantsContext);
    if (context === undefined) {
        throw new Error(
            "useStrapiConstants must be used within a StrapiConstantsProvider"
        );
    }
    return context;
};
